import type { StatusIntent } from './status-intent'

export type PreconditionVerdict =
  | { ok: true; evidence?: string }
  | { ok: false; reason: string; recovery?: { label: string; navigateTo: string } }

export interface Precondition {
  /** 온톨로지 id 패턴 ^[a-z][a-z0-9-]*$ */
  id: string
  /** 왜 이것이 필요한가 — 사용자가 읽는 한 문장 */
  explanation: string
  check: () => Promise<PreconditionVerdict>
}

export interface ScreenContract {
  screenId: string
  intent: string
  preconditions: Precondition[]
  states: Partial<Record<StatusIntent, { describes: string }>>
}

export interface PreconditionReport {
  ok: boolean
  verdicts: Array<{ id: string; explanation: string } & PreconditionVerdict>
}

/** check 가 던지면 조용히 통과시키지 않는다 — ok:false + reason 으로 접는다. */
export async function evaluatePreconditions(contract: ScreenContract): Promise<PreconditionReport> {
  const verdicts = await Promise.all(
    contract.preconditions.map(async (pre) => {
      try {
        const verdict = await pre.check()
        return { id: pre.id, explanation: pre.explanation, ...verdict }
      } catch (error) {
        return {
          id: pre.id,
          explanation: pre.explanation,
          ok: false as const,
          reason: `전제 확인 중 오류: ${error instanceof Error ? error.message : String(error)}`,
        }
      }
    }),
  )
  return { ok: verdicts.every((v) => v.ok), verdicts }
}
